module.exports = __webpack_public_path__ + "static/media/advantages_bar_right.37622594.svg";